import { Service } from "models/Service";
import {
  formatGuiaMundialCountryLabel,
  getGuiaMundialCountryPortadaCopy,
  getGuiaMundialRedirectPath,
  getGuiaMundialSquad,
  getGuiaMundialTeam,
  getGuiaMundialTeamProfile,
  GUIA_MUNDIAL_BASE_PATH,
  GUIA_MUNDIAL_PORTADA_IMAGE,
} from "./data";

export * from "./data";

/** Adserver: /242767168/clarin/mundialfutbol-2026/fichajugadores/{slot} */
export const GUIA_MUNDIAL_ADS_PATH = "clarin/mundialfutbol-2026/fichajugadores";

const getCountrySlug = (matchSegments = []) => {
  const idx = matchSegments.findIndex(
    (segment) => segment === GUIA_MUNDIAL_BASE_PATH
  );
  if (idx >= 0 && matchSegments.length > idx + 1) {
    return matchSegments
      .slice(idx + 1)
      .join("/")
      .replace(/\.html$/i, "");
  }
  return "";
};

export class GuiaMundial extends Service {
  constructor() {
    super({
      adsPath: GUIA_MUNDIAL_ADS_PATH,
      meta: {
        description:
          "Todo lo que necesitás saber (y más) sobre las 48 selecciones que competirán en la Copa del Mundo 2026. Hacé click en las fotos de los jugadores para ver un perfil completo y las puntuaciones de los partidos.",
        keywords: "guía mundial, mundial 2026, jugadores, selecciones, clarín",
        title:
          "Mundial 2026: guía completa de todos los jugadores | Clarín",
        url: GUIA_MUNDIAL_BASE_PATH,
        urlImage: GUIA_MUNDIAL_PORTADA_IMAGE,
        extra: [],
      },
      section: GUIA_MUNDIAL_BASE_PATH,
      sectionAds: GUIA_MUNDIAL_BASE_PATH,
      template: "GuiaMundial",
      title: "Guía Mundial",
      titleHeader: "",
      slug: GUIA_MUNDIAL_BASE_PATH,
      widthFull: true,
      width100: true,
      showLiveblog: false,
      showNewsToday: false,
      showBreadcrumbApp: false,
      autorefresh: true,
      classService: "guia-mundial-service",
      cssClass: "guia-mundial-header",
      bannerHorizontalOff: ["horizontal3"],
      subheaderEnable: true,
    });
  }

  parseData = (matchSegments = []) => {
    const countrySlug = getCountrySlug(matchSegments);
    const redirectPath = getGuiaMundialRedirectPath(countrySlug);
    if (redirectPath) {
      this.setData({ redirect: redirectPath });
      return;
    }

    const squad = getGuiaMundialSquad(countrySlug);
    const baseTeam = getGuiaMundialTeam(countrySlug);
    const team = baseTeam
      ? { ...baseTeam, squad, profile: getGuiaMundialTeamProfile(countrySlug) }
      : null;
    const pageUrl = countrySlug
      ? `${GUIA_MUNDIAL_BASE_PATH}/${countrySlug}`
      : GUIA_MUNDIAL_BASE_PATH;
    const pageTitle = countrySlug
      ? formatGuiaMundialCountryLabel(countrySlug)
      : "Guía Mundial";

    const countryPortadaCopy = countrySlug
      ? getGuiaMundialCountryPortadaCopy(pageTitle)
      : null;
    const metaTitle = countryPortadaCopy
      ? countryPortadaCopy.title
      : "Copa Mundial 2026: guía completa de todos los jugadores | Clarín";
    const metaDescription = countryPortadaCopy
      ? countryPortadaCopy.lead
      : "Todo lo que necesitás saber (y más) sobre las 48 selecciones que competirán en la Copa del Mundo 2026. Hacé click en las fotos de los jugadores para ver un perfil completo y las puntuaciones de los partidos.";

    this.setAdsPath(GUIA_MUNDIAL_ADS_PATH);
    this.setSlug(pageUrl);
    this.setTitle(metaTitle);
    this.setMeta(
      this.parseMeta({
        description: metaDescription,
        keywords: "guía mundial, mundial 2026, jugadores, selecciones, clarín",
        title: metaTitle,
        url: pageUrl,
        urlImage: GUIA_MUNDIAL_PORTADA_IMAGE,
        extra: [],
      })
    );
    this.setData({ countrySlug, pageUrl, pageTitle, team });
  };
}
